import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=2af35160&scoped=true&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"
import style0 from "./Theme.vue?vue&type=style&index=0&id=2af35160&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af35160",
  null
  
)

export default component.exports